import React, { useState } from "react";
import { Box, Container, Typography, IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const testimonialsData = [
  {
    quote:
      "“ Learn from yesterday, live for today, hope for tomorrow. The important thing is not to stop questioning.”",
    author: "Albert Einstein",
  },
  {
    quote:
      "“ Wise men speak because they have something to say; Fools because they have to say something.”",
    author: "Plato",
  },
  {
    quote:
      "“Imagination will often carry us to worlds that never were. But without it we go nowhere.”",
    author: "Carl Sagan",
  },
];

const Testimonials: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonialsData.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonialsData.length - 1 : prevIndex - 1,
    );
  };

  return (
    <Box
      id="section-testimonial"
      sx={{ py: 8, bgcolor: "primary.main", color: "white" }}
    >
      <Container maxWidth="md">
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h4"
            component="p"
            sx={{ fontStyle: "italic", mb: 3 }}
          >
            {testimonialsData[currentIndex].quote}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            {testimonialsData[currentIndex].author}
          </Typography>
          <Box
            sx={{
              mt: 4,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <IconButton onClick={handlePrev} color="inherit" sx={{ mr: 2 }}>
              <ArrowBackIosIcon />
            </IconButton>
            {testimonialsData.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  bgcolor:
                    index === currentIndex ? "white" : "rgba(255,255,255,0.5)",
                  mx: 0.5,
                  cursor: "pointer",
                }}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
            <IconButton onClick={handleNext} color="inherit" sx={{ ml: 2 }}>
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Testimonials;
